/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { Admin, Resource } from 'react-admin';
import { Route } from 'react-router-dom';

import { createBrowserHistory } from 'history';

import AssignmentIcon from '@material-ui/icons/Assignment';
import CollectionIcon from '@material-ui/icons/ViewModule';
import AccountIcon from '@material-ui/icons/AccountCircle';

import authProvider from './providers/auth-provider';
import dataProvider from './providers/data-provider';

import LoginPage from './LoginPage';
import { LogoutButton, ShareLayout } from './layout';
import { ThemesCreate, ThemesEdit, ThemesList } from './resources/Themes';
import { AssetsCreate, AssetsEdit, AssetsList } from './resources/assets';
import {
  CollectionsCreate,
  CollectionsEdit,
  CollectionsList,
} from './resources/collections';
import { CollectionsSortList } from './resources/collectionsSort';
import { ShowProfile } from './resources/profile';

const history = createBrowserHistory();

const App = () => (
  <Admin
    layout={ShareLayout}
    dataProvider={dataProvider}
    authProvider={authProvider}
    history={history}
    loginPage={LoginPage}
    logoutButton={LogoutButton}
    disableTelemetry
    customRoutes={[
      <Route key="profile" path="/my-profile" component={ShowProfile} />,
    ]}
  >
    {(permissions) => {
      const isAdmin = permissions.isAdmin;

      let resources = [
        <Resource
          name="assets"
          options={{ label: 'Assets' }}
          icon={AssignmentIcon}
          list={AssetsList}
          edit={isAdmin ? AssetsEdit : null}
          create={isAdmin ? AssetsCreate : null}
        />,
        <Resource
          name="collections"
          options={{ label: 'Collections' }}
          icon={CollectionIcon}
          list={CollectionsList}
          edit={isAdmin ? CollectionsEdit : null}
          create={isAdmin ? CollectionsCreate : null}
        />,
        <Resource
          name="collectionsSort"
          options={{ label: 'Sort Collections' }}
          icon={CollectionIcon}
          list={CollectionsSortList}
          edit={null}
          create={null}
        />,
        <Resource
          name="themes"
          options={{ label: 'Collection Themes' }}
          icon={CollectionIcon}
          list={ThemesList}
          edit={isAdmin ? ThemesEdit : null}
          create={isAdmin ? ThemesCreate : null}
        />,
        <Resource
          name="profile"
          options={{ label: 'My profile' }}
          icon={AccountIcon}
          show={ShowProfile}
        />,
      ];

      return resources;
    }}
  </Admin>
);

export default App;
